import React, { useState, useContext, useEffect } from 'react';
import './login.css';
import { auth, db, getAuth } from './firebase';
import { signInWithEmailAndPassword, signInWithPhoneNumber, RecaptchaVerifier, linkWithCredential, PhoneAuthProvider } from 'firebase/auth';
import { query, collection, where, getDocs, updateDoc, arrayUnion, addDoc } from 'firebase/firestore';
import { useNavigate, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPills } from '@fortawesome/free-solid-svg-icons';
import { useTenant } from './context/TenantContext';
import { setupRecaptcha } from './utils/recaptcha';

const Login = () => {
  const [formData, setFormData] = useState({ email: '', password: '', phone: '', otp: '' });
  const [error, setError] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isPhoneLogin, setIsPhoneLogin] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { setTenantId, setRole } = useTenant();

  const redirectPath = location.state?.from || '/dashboard';

  useEffect(() => {


    /*if (!window.recaptchaVerifier) {
    window.recaptchaVerifier = new RecaptchaVerifier('recaptcha-container', {
      size: 'invisible',
      callback: (response) => {
        // reCAPTCHA solved - allow sending OTP
      },
      'expired-callback': () => {
        // Optionally reset the reCAPTCHA if needed
        window.recaptchaVerifier.clear();
        window.recaptchaVerifier = null;
      },
    });
    window.recaptchaVerifier.render(); // 👈 renders the invisible reCAPTCHA properly
  };*/

  ///

  /*  if (isPhoneLogin && !window.recaptchaVerifier) {
      window.recaptchaVerifier = new RecaptchaVerifier(auth, 'recaptcha-container', {
        size: 'invisible',
        callback: () => {},
      });
    }
  }, [isPhoneLogin]); */

}, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleEmailLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const userCredential = await signInWithEmailAndPassword(auth, formData.email, formData.password);
      const user = userCredential.user;

      const q = query(collection(db, 'users'), where('uids', 'array-contains', user.uid));
      const querySnapshot = await getDocs(q);

      if (querySnapshot.empty) {
        throw new Error('User not found in Firestore.');
      }

      const userData = querySnapshot.docs[0].data();
      setTenantId(userData.tenantId);
      setRole(userData.role);

      navigate(redirectPath);
    } catch (err) {
      setError('Login failed: ' + err.message);
    }

    setLoading(false);
  };

  const handleSendOtp = async () => {
  setError('');
  setLoading(true);

  try {
    setupRecaptcha();
    const appVerifier = window.recaptchaVerifier;
    let formattedPhone = formData.phone.trim();
      if (!formattedPhone.startsWith('+91')) {
        formattedPhone = '+91' + formattedPhone.replace(/^0+/, ''); // remove leading 0s
      }

// Use formattedPhone instead of formData.phone
    const confirmationResult = await signInWithPhoneNumber(auth, formattedPhone, appVerifier);
    window.confirmationResult = confirmationResult;
    setOtpSent(true);
  } catch (error) {
    console.error(error);
    setError('Failed to send OTP: ' + error.message);
  }

  setLoading(false);
};

  const handleVerifyOtp = async () => {
  setError('');
  setLoading(true);

  try {
    const result = await window.confirmationResult.confirm(formData.otp);
    const user = result.user; // ✅ Phone-authenticated user

    // Query Firestore users collection for matching UID in `uids` array
    const q = query(collection(db, 'users'), where('uids', 'array-contains', user.uid));
    const querySnapshot = await getDocs(q);

    if (querySnapshot.empty) {
      setError('No user exists for this phone number');
      setLoading(false);
      return;
    }

    const userDoc = querySnapshot.docs[0];
    const userData = userDoc.data();

    // 🔄 Ensure this UID is added to the uids array (if not already)
    await updateDoc(userDoc.ref, {
      uids: arrayUnion(user.uid)
    });

    // ✅ Set tenant and role context for app
    setTenantId(userData.tenantId);
    setRole(userData.role);

    // ✅ Redirect to dashboard
    setTimeout(() => {
      navigate(redirectPath);
    }, 300); // small buffer to show loading
  } catch (err) {
    setError('Invalid OTP: ' + err.message);
  } finally {
    setLoading(false);
      document.body.style.cursor = 'default';
    }
  setLoading(false);
};




  return (
    <div className="login-container">
      <nav className="unauth-navbar" style={{ marginBottom: '20px' }}>
        <div className="unauth-logo" onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
          <FontAwesomeIcon icon={faPills} className="unauth-header-icon" /> ClinicSync
        </div>
      </nav>
      <h2 className="login-title">ClinicSync Login</h2>
      <div className="login-toggle">
        <button className={!isPhoneLogin ? 'active' : ''} onClick={() => setIsPhoneLogin(false)}>
          Email Login
        </button>
        <button className={isPhoneLogin ? 'active' : ''} onClick={() => setIsPhoneLogin(true)}>
          Phone Login
        </button>
      </div>

      {!isPhoneLogin ? (
        <form onSubmit={handleEmailLogin} className="login-form">
          <input
            type="email"
            name="email"
            placeholder="Email Address"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <input
            type="password"
            name="password"
            placeholder="Password"
            value={formData.password}
            onChange={handleChange}
            required
          />
          {error && <p className="error">{error}</p>}
          <button type="submit" className="login-button" disabled={loading}>
            {loading ? <div className="spinner"></div> : 'Login'}
          </button>
        </form>
      ) : (
        <div className="login-form">
          <input
            type="tel"
            name="phone"
            placeholder="+91XXXXXXXXXX"
            value={formData.phone}
            onChange={handleChange}
            required
          />
          {!otpSent ? (
            <button onClick={handleSendOtp} className="login-button" disabled={loading}>
              {loading ? 'Sending OTP...' : 'Send OTP'}
            </button>
          ) : (
            <>
              <input
                type="text"
                name="otp"
                placeholder="Enter OTP"
                value={formData.otp}
                onChange={handleChange}
                required
              />
              <button onClick={handleVerifyOtp} className="login-button" disabled={loading}>
                {loading ? 'Verifying...' : 'Verify & Login'}
              </button>
            </>
          )}
          {error && <p className="error">{error}</p>}
        </div>
      )}

      <div id="recaptcha-container"></div>
    </div>
    
  );
};

export default Login;
